export const GTM_TRACKING_KEY = process.env.REACT_APP_GTM_TRACKING_KEY;
